module.exports = ":host ::ng-deep .footer {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  text-align: center; }\n"